




















import { Component, Mixins } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import OzAlertDialogBox from 'library/v4/components/OzAlertDialogBox.vue'
import OzOverlay from 'library/v4/components/OzOverlay.vue'

const alertDialog = namespace('alertDialog')

@Component({
  components: {
    OzAlertDialogBox,
    OzOverlay,
  },
})
export default class GlobalAlertDialog extends Mixins() {
  // This component comes as a pair with the vuexstore/modules/global_alert_dialog.ts.
  // Items from other parts of the vuex store should be passed in as props.
  @alertDialog.State isOpen!: boolean
  @alertDialog.State title!: string
  @alertDialog.State body!: string
  @alertDialog.State closeButtonText!: string
  @alertDialog.State iconSrc!: string | null
  @alertDialog.State iconAlt!: string | null
  @alertDialog.State xShadow!: boolean
  @alertDialog.State shouldFadeIn!: boolean
  @alertDialog.Action close!: () => void
}
